import { CYCLE_LAYOUT } from '@amelio/ui-library';

import { cycleCardRadius, cycleCardShadow, cycleRailSurfaceBlur } from '@/utils/cycleStyles';

// The gradient goes through the `bgColor` prop and never this className: `Card` paints its own
// fill under a className gradient instead of replacing it, doubling the opacity.
const CYCLE_SURFACE_BASE = [
    `${cycleCardRadius} border`,
    cycleRailSurfaceBlur,
    cycleCardShadow,
].join(' ');

const CYCLE_CARD_SURFACE = `${CYCLE_SURFACE_BASE} ${CYCLE_LAYOUT.cardPadding}`;

const CYCLE_SECTION_SURFACE = `${CYCLE_SURFACE_BASE} ${CYCLE_LAYOUT.sectionPadding}`;

export { CYCLE_CARD_SURFACE, CYCLE_SECTION_SURFACE };
export { cycleRailSurfaceBorderColor as CYCLE_CARD_SURFACE_BORDER_COLOR } from '@/utils/cycleStyles';
export { cycleRailSurfaceGradient as CYCLE_CARD_SURFACE_BG_COLOR } from '@/utils/cycleStyles';
